function NotFound() {
    return (
        <div className='mt-5 text-center'>Page introuvable </div>
    )
}

export default NotFound